var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcShowAltGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "06A9FB2A-45BA-4C2B-8E80-B9BAA377436A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_02_05-Sign-Up-filled",
    transform: "translate(-888.000000, -734.000000)",
    fill: "#74818D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Welcome-Back",
    transform: "translate(495.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input/desible-Copy-2",
    transform: "translate(28.000000, 521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(365.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.946000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C15.8328029,0 17.8863139,6.14435714 17.9060076,6.20657143 L17.9060076,6.20657143 L18,6.5 L17.9051124,6.79342857 C17.8863139,6.85564286 15.8328029,13 9,13 C2.16719714,13 0.113686095,6.85564286 0.0939924408,6.79342857 L0.0939924408,6.79342857 L0,6.5 L0.0948876069,6.20657143 C0.113686095,6.14435714 2.16719714,0 9,0 Z M9,1.85714286 C4.21265168,1.85714286 2.35607718,5.42471429 1.90491347,6.5 C2.35428685,7.57157143 4.20996618,11.1428571 9,11.1428571 C13.7873483,11.1428571 15.6439228,7.57528571 16.0950865,6.5 C15.6457131,5.42842857 13.7900338,1.85714286 9,1.85714286 Z M9,3.71428571 C9.08235528,3.71428571 9.15933957,3.73285714 9.23990452,3.73935714 C9.09220211,4.00864286 9,4.31414286 9,4.64285714 C9,5.65964286 9.81012532,6.5 10.7903322,6.5 C11.107221,6.5 11.4017307,6.40435714 11.6613288,6.25114286 C11.667595,6.33471429 11.6854983,6.41457143 11.6854983,6.5 C11.6854983,8.02471429 10.4689676,9.28571429 9,9.28571429 C7.53013726,9.28571429 6.31450169,8.02471429 6.31450169,6.5 C6.31450169,4.97621429 7.53013726,3.71428571 9,3.71428571 Z",
    id: "Combined-Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShowAltGrey);
export default __webpack_public_path__ + "static/media/ic_show-alt_grey.ec0e19688e4afcc8fb5e2ea736075e97.svg";
export { ForwardRef as ReactComponent };